<template>
  <el-form
    ref="addTask"
    :model="navFrom"
    label-width="60px"
    class="reviewer-from"
  >
    <el-row>
      <el-form-item label="条线" prop="columnId">
        <el-select
          v-model="navFrom.line"
          multiple
          placeholder="全部"
          filterable
          clearable
          size="small"
          style="width: 100%"
          class="filter-item"
          @change="changeLine()"
        >
          <el-option
            v-for="item in line"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-col :span="24">
        <div class="table">
          <div class="table-header">
            <div>显示条件</div>
            <div>描述</div>
            <div>是否启用</div>
            <div>操作</div>
          </div>
          <div class="table-body" id="myTable">
            <div
              class="table-tr"
              v-for="(item, index) in configList"
              :key="item.id"
            >
              <div class="table-td">{{ item.condition }}</div>
              <div class="table-td">{{ item.describe }}</div>
              <div class="table-td">
                <el-switch
                  v-model="item.state === 0 ? value1 : value2"
                  @change="changeState(item)"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </div>
              <div class="table-td">
                <i
                  class="el-icon-top"
                  @click="moveUp(index)"
                  v-show="index !== 0"
                ></i>
                <i
                  class="el-icon-bottom"
                  @click="moveDown(index)"
                  v-show="index !== configList.length - 1"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { mapGetters } from "vuex";
import { selectDictDataByType } from "@/api/userManage.js";
import { getConfigInfoWithYh, updateConfig } from "@/api/question.js";

export default {
  name: "add",
  computed: {
    ...mapGetters([]),
  },
  components: {},
  data() {
    return {
      item: 0,
      value1: true,
      value2: false,
      navFrom: {},
      line: [],
      configList: [],
    };
  },
  created() {
    selectDictDataByType("pmp_quality_line", 1).then((res) => {
      if (res.code == 0) {
        this.line = res.data;
        getConfigInfoWithYh().then((res2) => {
          if (res2.code == 0) {
            res2.data.map((t, i) => {
              i === 0 ? null : this.configList.push(t);
            });
            this.navFrom.line =
              res2.data[0].condition === ""
                ? []
                : res2.data[0].condition.split(",");
          }
        });
      }
    });
  },
  mounted() {},
  methods: {
    changeLine() {
      const params = {
        condition: this.navFrom.line.toString(),
        configname: "cxtx",
        id: "1",
      };
      updateConfig(params);
    },
    changeState(item) {
      const params = {
        ...item,
        state: 1 - item.state,
      };
      updateConfig(params).then((res) => {
        if (res.code == 0) {
          getConfigInfoWithYh().then((res2) => {
            if (res2.code == 0) {
              this.configList = [];
              res2.data.map((t, i) => {
                i === 0 ? null : this.configList.push(t);
              });
            }
          });
        }
      });
    },
    moveUp(index) {
      const params = {
        configname: this.configList[index].configname,
        id: this.configList[index].id,
        position: Number(this.configList[index].position) - 1,
      };
      const params2 = {
        preconfigname: this.configList[index - 1].configname,
        id: this.configList[index - 1].id,
        preposition: Number(this.configList[index - 1].position) + 1,
      };
      updateConfig(params).then((res) => {
        if (res.code == 0) {
          updateConfig(params2).then((res3) => {
            if (res3.code == 0) {
              getConfigInfoWithYh().then((res2) => {
                if (res2.code == 0) {
                  this.configList = [];
                  res2.data.map((t, i) => {
                    i === 0 ? null : this.configList.push(t);
                  });
                }
              });
            }
          });
        }
      });
    },
    moveDown(index) {
      const params = {
        configname: this.configList[index].configname,
        id: this.configList[index].id,
        position: Number(this.configList[index].position) + 1,
      };
      const params2 = {
        preconfigname: this.configList[index + 1].configname,
        id: this.configList[index + 1].id,
        preposition: Number(this.configList[index + 1].position) - 1,
      };
      updateConfig(params).then((res) => {
        if (res.code == 0) {
          updateConfig(params2).then((res3) => {
            if (res3.code == 0) {
              getConfigInfoWithYh().then((res2) => {
                if (res2.code == 0) {
                  this.configList = [];
                  res2.data.map((t, i) => {
                    i === 0 ? null : this.configList.push(t);
                  });
                }
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .table-td:nth-of-type(3) {
        padding-top: 13px;
      }
      .table-td:nth-of-type(4) {
        padding-top: 13px;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
.uploadButton {
  text-align: right;
  margin-top: 10px;
}
</style>